const TIME_SERIES_WIDGET_TYPES = new Set(['chart', 'table', 'period-column']);

export const shouldApplyDatastreamBounds = (widgetType) =>
  !TIME_SERIES_WIDGET_TYPES.has(String(widgetType || '').trim().toLowerCase());
